// extracted by mini-css-extract-plugin
var _1 = "tkDxT";
var _2 = "KZHgI";
var _3 = "aLhh7";
var _4 = "Qj_cA";
var _5 = "nTSop";
export { _1 as "panelContent", _2 as "panelFooter", _3 as "panelHeader", _4 as "panelWrapper", _5 as "skipLink" }
